import { render, staticRenderFns } from "./TabTripInclusions.vue?vue&type=template&id=3ce0e3f6&"
import script from "./TabTripInclusions.vue?vue&type=script&lang=js&"
export * from "./TabTripInclusions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports